<div class="mx-auto p-6 bg-white">
    <!-- Header -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
        <div class="flex items-center gap-4">
            <h1 class="text-3xl font-bold">Agregar Participantes</h1>
        </div>
        <button (click)="cancel()"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            Cancelar
        </button>
    </div>

    <!-- Subtitle con info de inscripción -->
    <div *ngIf="enrollmentDetails"
        class="mb-6 p-4 bg-gradient-to-r from-indigo-50 to-blue-50 rounded-lg border border-indigo-200">
        <div class="flex items-center gap-2">
            <span class="text-2xl">🏢</span>
            <div>
                <p class="font-semibold text-gray-800">{{ enrollmentDetails.company?.name }}</p>
                <p class="text-sm text-gray-600">{{ enrollmentDetails.project?.name }}</p>
            </div>
        </div>
    </div>

    <!-- Steps indicator -->
    <div class="flex items-center justify-center mb-8" *ngIf="enrollmentDetails">
        <div class="flex items-center">
            <div class="flex items-center cursor-pointer" (click)="goToStep(1)">
                <div
                    [class]="step >= 1 ? 'w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold' : 'w-10 h-10 bg-gray-200 text-gray-600 rounded-full flex items-center justify-center font-bold'">
                    1</div>
                <span class="ml-2 text-sm font-medium"
                    [class]="step >= 1 ? 'text-blue-600' : 'text-gray-500'">Participantes</span>
            </div>
            <div class="w-16 h-1 mx-4" [class]="step >= 2 ? 'bg-blue-500' : 'bg-gray-200'"></div>
            <div class="flex items-center cursor-pointer" (click)="goToStep(2)">
                <div
                    [class]="step >= 2 ? 'w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold' : 'w-10 h-10 bg-gray-200 text-gray-600 rounded-full flex items-center justify-center font-bold'">
                    2</div>
                <span class="ml-2 text-sm font-medium" [class]="step >= 2 ? 'text-blue-600' : 'text-gray-500'">Plan de
                    Pagos</span>
            </div>
            <div class="w-16 h-1 mx-4" [class]="step >= 3 ? 'bg-blue-500' : 'bg-gray-200'"></div>
            <div class="flex items-center cursor-pointer" (click)="goToStep(3)">
                <div
                    [class]="step >= 3 ? 'w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold' : 'w-10 h-10 bg-gray-200 text-gray-600 rounded-full flex items-center justify-center font-bold'">
                    3</div>
                <span class="ml-2 text-sm font-medium"
                    [class]="step >= 3 ? 'text-blue-600' : 'text-gray-500'">Confirmación</span>
            </div>
        </div>
    </div>

    <ng-container *ngIf="enrollmentDetails">

        <!-- Step 1: Participantes -->
        <div *ngIf="step === 1" class="bg-white p-6 rounded-lg shadow-sm mb-6">
            <div class="flex items-center justify-between mb-6">
                <div class="flex items-center">
                    <div class="w-2 h-8 bg-blue-500 rounded mr-3"></div>
                    <h3 class="text-lg font-semibold text-gray-800">Nuevos Participantes</h3>
                </div>
                <button type="button" (click)="addParticipant()"
                    class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd"></path>
                    </svg>
                    Agregar Colaborador
                </button>
            </div>

            <!-- Info banner -->
            <div *ngIf="inscriptionAmount > 0" class="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <div class="flex items-center gap-2">
                    <svg class="w-5 h-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clip-rule="evenodd"></path>
                    </svg>
                    <span class="text-sm text-blue-700">Monto de inscripción por participante: <strong>{{ currencySymbol
                            }}{{ formatCurrency(inscriptionAmount) }}</strong></span>
                </div>
            </div>

            <!-- Mensaje cuando no hay participantes -->
            <div *ngIf="businessParticipants.length === 0"
                class="text-center py-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-2.25M13 7a4 4 0 11-8 0 4 4 0 018 0z">
                    </path>
                </svg>
                <h3 class="mt-2 text-sm font-medium text-gray-900">Sin colaboradores</h3>
                <p class="mt-1 text-sm text-gray-500">Agregue al menos un colaborador para continuar</p>
            </div>

            <!-- Tarjetas de participantes -->
            <div *ngFor="let participant of businessParticipants; let i = index"
                class="border border-gray-200 rounded-lg p-6 mb-4 hover:shadow-md transition-shadow">

                <!-- Header de la tarjeta -->
                <div class="flex items-center justify-between mb-4 pb-3 border-b border-gray-100">
                    <div class="flex items-center">
                        <div
                            class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold mr-3">
                            {{ i + 1 }}
                        </div>
                        <div>
                            <h5 class="font-semibold text-gray-800">Colaborador #{{ i + 1 }}</h5>
                            <p class="text-xs text-gray-500">Configuración de cobertura</p>
                        </div>
                    </div>

                    <button type="button" (click)="removeParticipant(i)"
                        class="text-red-600 hover:text-red-800 hover:bg-red-50 p-2 rounded-full transition-colors">
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clip-rule="evenodd"></path>
                        </svg>
                    </button>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <!-- Participante -->
                    <div>
                        <label class="block text-sm font-semibold text-gray-700 mb-2" appRequiredLabel>👤
                            Participante</label>
                        <p-dropdown [filter]="true" [showClear]="true" [options]="participants"
                            [(ngModel)]="participant.participantId" [ngModelOptions]="{standalone: true}"
                            optionLabel="firstName" optionValue="id" (ngModelChange)="onParticipantChange(i)"
                            (onFilter)="onSearchParticipant($event)" placeholder="Seleccione un participante"
                            class="w-full custom-dropdown" appendTo="body">
                            <ng-template let-p pTemplate="item">
                                <span>{{ p.typeDocument }} {{ p.documentId }} {{ p.firstName }} {{ p.lastName }}</span>
                            </ng-template>
                            <ng-template let-p pTemplate="selectedItem">
                                <span *ngIf="p">{{ p.firstName }} {{ p.lastName }}</span>
                            </ng-template>
                        </p-dropdown>
                    </div>

                    <!-- Tipo de cobertura -->
                    <div>
                        <label class="block text-sm font-semibold text-gray-700 mb-2" appRequiredLabel>💼 Tipo de
                            Cobertura</label>
                        <select [(ngModel)]="participant.coverageType" [ngModelOptions]="{standalone: true}"
                            (change)="onCoverageTypeChange(i)"
                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                            <option [value]="CoverageType.FULL">100% Empresa (Gratis para colaborador)</option>
                            <option [value]="CoverageType.PERCENTAGE">% Empresa (Resto colaborador)</option>
                            <option [value]="CoverageType.FIXED">Valor fijo empresa (Resto colaborador)</option>
                            <option [value]="CoverageType.NONE">0% Empresa (100% colaborador)</option>
                        </select>
                    </div>

                    <!-- Valor de cobertura -->
                    <div>
                        <label class="block text-sm font-semibold text-gray-700 mb-2">
                            💰
                            <span *ngIf="participant.coverageType === CoverageType.PERCENTAGE">Porcentaje (%)</span>
                            <span *ngIf="participant.coverageType === CoverageType.FIXED">Valor (COP)</span>
                            <span
                                *ngIf="participant.coverageType === CoverageType.FULL || participant.coverageType === CoverageType.NONE">-</span>
                        </label>
                        <input type="number" [(ngModel)]="participant.coverageValue"
                            [ngModelOptions]="{standalone: true}" (ngModelChange)="onCoverageValueChange(i)"
                            [disabled]="participant.coverageType === CoverageType.FULL || participant.coverageType === CoverageType.NONE"
                            [placeholder]="participant.coverageType === CoverageType.PERCENTAGE ? 'Ej: 50' : 'Ej: 1000000'"
                            [min]="0"
                            [max]="participant.coverageType === CoverageType.PERCENTAGE ? 100 : inscriptionAmount"
                            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100" />
                    </div>
                </div>

                <!-- Visualización de cobertura -->
                <div class="mt-4 p-3 bg-gray-50 rounded-lg">
                    <div class="text-sm">
                        <span class="font-medium text-gray-700">Distribución de costos:</span>
                        <div class="mt-1 flex justify-between">
                            <span>Empresa paga: <span class="font-semibold text-green-600">{{ currencySymbol }}{{
                                    formatCurrency(calculateCoverageDistribution(participant).companyAmount)
                                    }}</span></span>
                            <span>Colaborador paga: <span class="font-semibold text-blue-600">{{ currencySymbol }}{{
                                    formatCurrency(calculateCoverageDistribution(participant).participantAmount)
                                    }}</span></span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Resumen totales -->
            <div *ngIf="businessParticipants.length > 0" class="mt-6 p-4 bg-gray-50 rounded-lg">
                <div class="grid grid-cols-2 gap-4 text-center">
                    <div>
                        <div class="text-sm text-gray-600">{{ currencySymbol }}{{
                            formatCurrency(totalNewParticipantsAmount) }}</div>
                        <div class="text-xs text-gray-500">Total empresa pagará (nuevos)</div>
                    </div>
                    <div>
                        <div class="text-sm text-gray-600">{{ currencySymbol }}{{
                            formatCurrency(totalParticipantPayAmount) }}</div>
                        <div class="text-xs text-gray-500">Total participantes pagarán (nuevos)</div>
                    </div>
                </div>
            </div>

            <!-- Botones de navegación -->
            <div class="flex justify-between mt-6 pt-4 border-t border-gray-200">
                <button type="button" (click)="cancel()"
                    class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                    Cancelar
                </button>
                <button type="button" (click)="goToStep(2)" [disabled]="!canProceedToStep2()"
                    class="inline-flex items-center px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed">
                    Siguiente
                    <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                </button>
            </div>
        </div>

        <!-- Step 2: Plan de Pagos -->
        <div *ngIf="step === 2" class="bg-white p-6 rounded-lg shadow-sm mb-6">
            <div class="flex items-center justify-between mb-6">
                <div class="flex items-center">
                    <div class="w-2 h-8 bg-blue-500 rounded mr-3"></div>
                    <h3 class="text-lg font-semibold text-gray-800">Plan de Pagos de Empresa (Actualizado)</h3>
                </div>
                <div class="flex items-center gap-3">
                    <button type="button" (click)="distributeCompanyAmount()"
                        class="bg-green-100 hover:bg-green-200 text-green-700 px-3 py-1 rounded-md text-sm transition-colors">
                        🧮 Distribuir automáticamente
                    </button>
                    <button type="button" (click)="addCompanyPlan()"
                        class="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition-colors">
                        <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                                clip-rule="evenodd"></path>
                        </svg>
                        Agregar Cuota
                    </button>
                </div>
            </div>

            <!-- Nota sobre herencia del plan maestro -->
            <div class="mb-6 p-4 bg-indigo-50 rounded-lg border border-indigo-200">
                <div class="flex items-start gap-3">
                    <svg class="w-5 h-5 text-indigo-500 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clip-rule="evenodd"></path>
                    </svg>
                    <div>
                        <p class="text-sm font-semibold text-indigo-800">Planes de Participantes</p>
                        <p class="text-sm text-indigo-700">Los nuevos participantes heredarán automáticamente el
                            <strong>Plan de Pago Maestro</strong> existente para calcular sus cuotas individuales.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Plan Maestro Existente (Solo Lectura) -->
            <div *ngIf="masterPaymentPlans.length > 0" class="mb-6 border border-gray-200 rounded-lg p-4 bg-gray-50">
                <h5 class="text-sm font-semibold text-gray-700 mb-3 flex items-center">
                    <span class="text-lg mr-2">📋</span>
                    Plan Maestro Existente (Solo Lectura)
                    <span class="ml-2 text-xs bg-gray-200 text-gray-600 px-2 py-0.5 rounded">Los participantes heredarán
                        este plan</span>
                </h5>
                <div class="overflow-x-auto">
                    <table class="min-w-full divide-y divide-gray-200 text-sm">
                        <thead class="bg-gray-100">
                            <tr>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">#</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Fecha
                                    Vencimiento</th>
                                <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase">Monto por
                                    Participante</th>
                            </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                            <tr *ngFor="let plan of masterPaymentPlans; let i = index">
                                <td class="px-3 py-2 text-gray-600">{{ i + 1 }}</td>
                                <td class="px-3 py-2 text-gray-600">{{ plan.dueDate | date:'dd/MM/yyyy' }}</td>
                                <td class="px-3 py-2 text-gray-600">{{ currencySymbol }}{{
                                    formatCurrency(plan.amountToPay) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Banner de nuevo monto -->
            <div class="mb-6 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                <div class="flex items-center gap-2">
                    <svg class="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd"></path>
                    </svg>
                    <span class="text-sm text-yellow-700">El monto total de la empresa aumentará en <strong>{{
                            currencySymbol }}{{ formatCurrency(totalNewParticipantsAmount) }}</strong> por los nuevos
                        participantes.</span>
                </div>
            </div>

            <!-- Control de Distribución -->
            <div class="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 mb-6">
                <h6 class="text-sm font-semibold text-blue-800 mb-3 flex items-center">
                    <span class="mr-2">📊</span>
                    Control de Distribución - Plan de Empresa
                </h6>
                <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <!-- Total original -->
                    <div class="text-center p-3 bg-white rounded-lg border border-blue-200">
                        <div class="text-lg font-bold text-gray-600">{{ currencySymbol }}{{
                            formatCurrency(existingCompanyTotal) }}</div>
                        <div class="text-xs text-gray-600">Total Original</div>
                    </div>
                    <!-- Total nuevos -->
                    <div class="text-center p-3 bg-white rounded-lg border border-blue-200">
                        <div class="text-lg font-bold text-green-600">+ {{ currencySymbol }}{{
                            formatCurrency(totalNewParticipantsAmount) }}</div>
                        <div class="text-xs text-gray-600">Nuevos Participantes</div>
                    </div>
                    <!-- Total objetivo -->
                    <div class="text-center p-3 bg-white rounded-lg border border-blue-200">
                        <div class="text-lg font-bold text-blue-600">{{ currencySymbol }}{{
                            formatCurrency(getTargetCompanyAmount()) }}</div>
                        <div class="text-xs text-blue-700">Total Objetivo</div>
                    </div>
                    <!-- Restante por asignar -->
                    <div class="text-center p-3 bg-white rounded-lg border border-blue-200">
                        <div class="text-lg font-bold" [ngClass]="{
                            'text-gray-600': getCompanyRemainingAmount() === 0,
                            'text-orange-600': getCompanyRemainingAmount() > 0,
                            'text-red-600': getCompanyRemainingAmount() < 0
                        }">
                            {{ currencySymbol }}{{ formatCurrency(Math.abs(getCompanyRemainingAmount())) }}
                        </div>
                        <div class="text-xs text-gray-700">
                            {{ getCompanyRemainingAmount() === 0 ? '✅ Distribución Completa' :
                            getCompanyRemainingAmount() > 0 ? '⚠️ Falta por Asignar' :
                            '❌ Exceso Asignado' }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tabla de planes -->
            <div *ngIf="companyPaymentPlans.length > 0" class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                        <tr>
                            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">#</th>
                            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fecha de
                                Vencimiento</th>
                            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Monto</th>
                            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Observaciones
                            </th>
                            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase"></th>
                        </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                        <tr *ngFor="let plan of companyPaymentPlans; let i = index">
                            <td class="px-4 py-3 text-sm text-gray-900">{{ plan.installmentNumber }}</td>
                            <td class="px-4 py-3">
                                <p-calendar [(ngModel)]="plan.dueDate" [ngModelOptions]="{standalone: true}"
                                    dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"></p-calendar>
                            </td>
                            <td class="px-4 py-3">
                                <p-inputNumber [(ngModel)]="plan.amountToPay" [ngModelOptions]="{standalone: true}"
                                    [min]="0" mode="currency" currency="COP" locale="es-CO"
                                    (onInput)="onCompanyPlanAmountChange()"></p-inputNumber>
                            </td>
                            <td class="px-4 py-3">
                                <input type="text" [(ngModel)]="plan.observations" [ngModelOptions]="{standalone: true}"
                                    placeholder="Observaciones..."
                                    class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500">
                            </td>
                            <td class="px-4 py-3">
                                <button type="button" (click)="removeCompanyPlan(i)"
                                    [disabled]="companyPaymentPlans.length <= 1"
                                    class="text-red-600 hover:text-red-800 disabled:text-gray-300">
                                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                        <path fill-rule="evenodd"
                                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot class="bg-gray-100">
                        <tr>
                            <th colspan="2" class="px-4 py-3 text-left text-sm font-semibold text-gray-900">Total</th>
                            <th class="px-4 py-3 text-left text-sm font-bold text-green-600">{{ currencySymbol }}{{
                                formatCurrency(totalCompanyAmount) }}</th>
                            <th colspan="2"></th>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <!-- Botones de navegación -->
            <div class="flex justify-between mt-6 pt-4 border-t border-gray-200">
                <button type="button" (click)="goToStep(1)"
                    class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                    <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7">
                        </path>
                    </svg>
                    Anterior
                </button>
                <button type="button" (click)="goToStep(3)"
                    class="inline-flex items-center px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700">
                    Siguiente
                    <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                </button>
            </div>
        </div>

        <!-- Step 3: Confirmación -->
        <div *ngIf="step === 3" class="bg-white p-6 rounded-lg shadow-sm mb-6">
            <div class="flex items-center mb-6">
                <div class="w-2 h-8 bg-green-500 rounded mr-3"></div>
                <h3 class="text-lg font-semibold text-gray-800">Confirmar Cambios</h3>
            </div>

            <!-- Resumen de inscripción -->
            <div class="mb-6 p-4 bg-gradient-to-r from-indigo-50 to-blue-50 rounded-lg border border-indigo-200">
                <h4 class="font-semibold text-gray-800 mb-2">Inscripción Corporativa</h4>
                <p class="text-sm text-gray-600"><strong>Empresa:</strong> {{ enrollmentDetails.company?.name }}</p>
                <p class="text-sm text-gray-600"><strong>Proyecto:</strong> {{ enrollmentDetails.project?.name }}</p>
            </div>

            <!-- Lista de participantes -->
            <div class="mb-6">
                <h4 class="font-semibold text-gray-800 mb-4">Nuevos Participantes ({{ businessParticipants.length }})
                </h4>
                <div *ngFor="let p of businessParticipants"
                    class="p-4 bg-gray-50 rounded-lg mb-2 flex justify-between items-center">
                    <div>
                        <span class="font-medium">{{ getParticipantName(p.participantId) }}</span>
                        <span class="text-gray-500 ml-2 text-sm">{{ getCoverageTypeLabel(p.coverageType) }}</span>
                    </div>
                    <div class="text-sm">
                        <span class="text-green-600">Empresa: {{ currencySymbol }}{{
                            formatCurrency(calculateCoverageDistribution(p).companyAmount) }}</span>
                        <span class="text-gray-400 mx-2">|</span>
                        <span class="text-blue-600">Participante: {{ currencySymbol }}{{
                            formatCurrency(calculateCoverageDistribution(p).participantAmount) }}</span>
                    </div>
                </div>
            </div>

            <!-- Resumen financiero -->
            <div class="mb-6 p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg border border-green-200">
                <h4 class="font-semibold text-gray-800 mb-4 flex items-center">
                    <span class="text-2xl mr-2">💰</span>
                    Resumen Financiero
                </h4>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div class="text-center p-4 bg-white rounded-lg shadow-sm">
                        <div class="text-xl font-bold text-green-600">{{ currencySymbol }}{{
                            formatCurrency(totalNewParticipantsAmount) }}</div>
                        <div class="text-sm text-gray-600">Total empresa (nuevos)</div>
                    </div>
                    <div class="text-center p-4 bg-white rounded-lg shadow-sm">
                        <div class="text-xl font-bold text-blue-600">{{ currencySymbol }}{{
                            formatCurrency(totalParticipantPayAmount) }}</div>
                        <div class="text-sm text-gray-600">Total participantes (nuevos)</div>
                    </div>
                    <div class="text-center p-4 bg-white rounded-lg shadow-sm">
                        <div class="text-xl font-bold text-purple-600">{{ currencySymbol }}{{
                            formatCurrency(totalCompanyAmount) }}</div>
                        <div class="text-sm text-gray-600">Plan empresa actualizado</div>
                    </div>
                </div>
            </div>

            <!-- Aviso de links de pago automáticos -->
            <div class="mb-6 p-4 bg-cyan-50 rounded-lg border border-cyan-200">
                <div class="flex items-start gap-3">
                    <svg class="w-5 h-5 text-cyan-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
                            clip-rule="evenodd"></path>
                    </svg>
                    <div>
                        <p class="text-sm font-semibold text-cyan-800">🔗 Links de Pago Automáticos</p>
                        <p class="text-sm text-cyan-700">Al confirmar, se generarán automáticamente los <strong>links de
                                pago de la primera cuota</strong> para cada nuevo participante y se les notificará por
                            correo electrónico.</p>
                    </div>
                </div>
            </div>

            <!-- Botones de navegación -->
            <div class="flex justify-between mt-6 pt-4 border-t border-gray-200">
                <button type="button" (click)="goToStep(2)"
                    class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                    <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7">
                        </path>
                    </svg>
                    Anterior
                </button>
                <button type="button" (click)="submit()" [disabled]="!isFormValid()"
                    class="inline-flex items-center px-6 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed">
                    <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd"></path>
                    </svg>
                    Confirmar y Guardar
                </button>
            </div>
        </div>

    </ng-container>

    <!-- Loading state -->
    <div *ngIf="!enrollmentDetails && isLoading" class="text-center py-12">
        <svg class="animate-spin h-8 w-8 text-blue-500 mx-auto mb-4" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
        </svg>
        <p class="text-gray-500">Cargando información...</p>
    </div>
</div>

<!-- Modal de Confirmación -->
<app-confirmation-modal #confirmationModal [isVisible]="showConfirmationModal" [config]="confirmationConfig"
    (confirmed)="onConfirmationModalConfirmed()" (cancelled)="onConfirmationModalCancelled()"
    (closed)="onConfirmationModalClosed()">
</app-confirmation-modal>